module.exports = __webpack_public_path__ + "img/2892402-57-0.ed38f4c5.png";